import moment from "moment";
import _ from "lodash";

const checkIfIsInDateRange = (date, selectedWeek) => {
  let isInDateRange = true;

  if (selectedWeek[0] !== "All dates") {
    isInDateRange = moment
      .utc(date)
      .isBetween(selectedWeek[0], selectedWeek[1], null, "[]");
  }

  return isInDateRange;
};

const calcOrganisations = (organisations, selectedWeek) => {
  const organisationsValue = organisations.filter((organisation) => {
    const createdAtDate = moment(organisation.created_at).format("DD MMM YYYY");

    const isInDateRange = checkIfIsInDateRange(createdAtDate, selectedWeek);

    return isInDateRange;
  }).length;

  return organisationsValue;
};

const calcApprovedOrganisations = (organisations, selectedWeek) => {
  const approvedOrganisationsValue = organisations.filter((organisation) => {
    const createdAtDate = moment(organisation.created_at).format("DD MMM YYYY");

    const isInDateRange = checkIfIsInDateRange(createdAtDate, selectedWeek);

    const isApproved = organisation.status === "published";

    return isInDateRange && isApproved;
  }).length;

  return approvedOrganisationsValue;
};

const calcServices = (services, selectedWeek) => {
  const servicesValue = services.filter((organisation) => {
    const createdAtDate = moment(organisation.created_at).format("DD MMM YYYY");

    const isInDateRange = checkIfIsInDateRange(createdAtDate, selectedWeek);

    return isInDateRange;
  }).length;

  return servicesValue;
};

const calcUnapprovedOrganisation = (organisations, selectedWeek) => {
  const unpprovedOrganisationsValue = organisations.filter((organisation) => {
    const createdAtDate = moment(organisation.created_at).format("DD MMM YYYY");

    const isInDateRange = checkIfIsInDateRange(createdAtDate, selectedWeek);

    const isUnapproved =
      organisation.status !== "published" && organisation.status !== "rejected";

    return isInDateRange && isUnapproved;
  }).length;

  return unpprovedOrganisationsValue;
};

const calcNeighbourhoods = (services, neighbourhood, selectedWeek) => {
  const duplicateService = [...services];

  let i = 0;
  while (i < services.length) {
    // check if any services have multiple locations
    if (services[i].locations.length > 1) {
      // store the locations for the specific service
      const locationsArray = services[i].locations;
      // iterate through each locationsArray and push to thisService.locations
      for (const [key, value] of Object.entries(locationsArray.slice(1))) {
        // duplicate the specific service
        const thisService = { ...services[i] };
        // reset the specific service locations array to be rewritten
        thisService.locations = [];
        // push specific service location object value into the empty array
        thisService.locations.push(value);
        // push thisService into duplicateService
        duplicateService.push(thisService);
      }
    }
    i++;
  }

  const neighbourhoodCount = duplicateService.filter((service) => {
    // ignore services without locations
    if (service.locations[0] !== undefined) {
      const createdAtDate = moment(service.created_at).format("DD MMM YYYY");

      const isInDateRange = checkIfIsInDateRange(createdAtDate, selectedWeek);

      const isNeighbourhood = service.locations[0].nhs_neighbourhood === neighbourhood;

      return isInDateRange && isNeighbourhood;
    }
  }).length;

  const neighbourhoodArray = [];
  neighbourhoodArray.count = neighbourhoodCount;
  return neighbourhoodArray;
};

const calcTotalNeighbourhoods = (services, neighbourhood) => {
  const locationArray = [];

  for (let i = 0; i < services.length; i++) {
    services[i].locations.forEach(function (item, index) {
      locationArray.push(item);
    });
  }

  const neighbourhoodCount = locationArray.reduce(function (n, val) {
    return n + (val.nhs_neighbourhood === neighbourhood);
  }, 0);

  const neighbourhoodArray = [];
  neighbourhoodArray.count = neighbourhoodCount;
  return neighbourhoodArray;
};

const calcDateRange = () => {
  const weeks = [];
  let startDate = moment(new Date(2020, 0, 1)).isoWeekday(8);
  if (startDate.date() == 8) {
    startDate = startDate.isoWeekday(-6);
  }
  const today = moment().isoWeekday("Sunday");
  while (startDate.isBefore(today)) {
    const startDateWeek = startDate.isoWeekday("Monday").format("DD MMM YYYY");
    const endDateWeek = startDate.isoWeekday("Sunday").format("DD MMM YYYY");
    startDate.add(7, "days");
    weeks.push({
      dateLabel: `${startDateWeek} - ${endDateWeek}`,
      dateRaw: [startDateWeek, endDateWeek],
    });
  }
  weeks.push({
    dateLabel: "All dates",
    dateRaw: ["All dates"],
  });
  return weeks.reverse();
};

export {
  calcOrganisations,
  calcApprovedOrganisations,
  calcServices,
  calcNeighbourhoods,
  calcTotalNeighbourhoods,
  calcUnapprovedOrganisation,
  calcDateRange,
};
